<template>
  <div>
    <van-popup v-model="show" closeable @click-close-icon="close">
      <div class="succes-box">
        <div class="succes-icon">
          <img src="@/assets/signUp/icons_succes.png" alt="" />
        </div>
        <div class="succes-tip">
          <span style="padding-left:15px;">提交成功！</span>
        </div>
        <div class="close-tip" @click="close">关闭窗口({{ num }}s)</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "success",
  data() {
    return {
      show: false,
      num: 5,
      time: null
    }
  },

  methods: {
    countDown() {
      this.num = 5
      this.time = setInterval(() => {
        if (this.num === 1) {
          clearInterval(this.time)
          this.show = false
          this.$emit("close")
          this.go()
        }
        this.num--
      }, 1000)
    },
    close() {
      this.show = false
      this.$emit("close")
      clearInterval(this.time)
      this.go()
    },
    go() {
      this.$router.push({
        name: "recharge",
        params: {
          rechargeTyep: 3
        }
      })
    }
  },
  created() {},
  mounted() {}
}
</script>

<style scoped lang="less">
.succes-icon {
  width: 280px;
  margin: 70px auto 30px;
  text-align: center;
}
.succes-tip {
  display: flex;
  justify-content: center;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
}
.close-tip {
  display: flex;
  justify-content: center;
  margin: 74px auto 10px;
  height: 17px;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
</style>
